import { render, staticRenderFns } from "./NewBroadcast.vue?vue&type=template&id=487845ba&scoped=true"
import script from "./NewBroadcast.vue?vue&type=script&lang=js"
export * from "./NewBroadcast.vue?vue&type=script&lang=js"
import style0 from "./NewBroadcast.vue?vue&type=style&index=0&id=487845ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487845ba",
  null
  
)

export default component.exports